import React, { useEffect, useRef, useState } from 'react';
import { Clock } from 'lucide-react';
import { formatCountdown } from './medicalApprovalEmail';

/**
 * "Approval email to parent in 9:58 — switch off to cancel", ticking every second until `sendAt`
 * (ms, server time; `clockOffset` corrects the browser's clock). At zero it shows "Sending…" and
 * calls `onElapsed` once, so the page can re-fetch and show "sent".
 */
const EmailCountdown = ({ sendAt, clockOffset = 0, onElapsed }) => {
    const remainingNow = () => sendAt - (Date.now() + clockOffset);
    const [remaining, setRemaining] = useState(remainingNow);
    const elapsedCalled = useRef(false);

    useEffect(() => {
        elapsedCalled.current = false;
        setRemaining(remainingNow());
        const timer = setInterval(() => {
            const left = remainingNow();
            setRemaining(left);
            if (left <= 0) {
                clearInterval(timer);
                if (!elapsedCalled.current) {
                    elapsedCalled.current = true;
                    onElapsed && onElapsed();
                }
            }
        }, 1000);
        return () => clearInterval(timer);
        // Restart only when the send time changes (re-approve); onElapsed is a fresh closure each render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sendAt, clockOffset]);

    return (
        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-amber-700" role="status">
            <Clock className="tw-h-3.5 tw-w-3.5 tw-shrink-0" aria-hidden="true" />
            {remaining > 0
                ? <span>Approval email to parent in <b className="tw-tabular-nums">{formatCountdown(remaining)}</b> — switch off to cancel</span>
                : <span>Sending approval email…</span>}
        </span>
    );
};

export default EmailCountdown;
